import { phrasing } from "mdast-util-phrasing";
import {
  attributesHeadingSchema,
  attributesPageTitleSchema
} from "../../elements/headings/attributes.js";
import {
  guideHeadingHtml,
  guidePageTitleHtml,
  ScalarHeadingVue,
  ScalarPageTitleVue
} from "../../elements/headings/component.js";
import { validate } from "../../helpers/validate.js";
import { hydrate } from "./hydration.js";
const scalarHeading = {
  name: "scalar-heading",
  tagName: "scalar-heading",
  tiptapName: "custom_heading",
  attributeTransform: (_, attrs) => {
    return validate(attributesHeadingSchema, attrs);
  },
  render: async (props) => guideHeadingHtml(props),
  markdownHandler: (state, node) => {
    const rawLevel = node.properties?.level;
    const numericLevel = typeof rawLevel === "number" ? rawLevel : Number(rawLevel);
    const depthNum = numericLevel >= 1 && numericLevel <= 6 ? numericLevel : 1;
    const depth = depthNum;
    const rawChildren = state.all(node);
    const children = rawChildren.filter(
      (n) => phrasing(n)
    );
    return [
      {
        type: "heading",
        depth,
        children
      }
    ];
  }
};
const scalarPageTitle = {
  name: "scalar-page-title",
  tagName: "scalar-page-title",
  tiptapName: "custom_page_title",
  attributeTransform: (_, attrs) => {
    return validate(attributesPageTitleSchema, attrs);
  },
  render: async (props) => guidePageTitleHtml(props),
  hydrate
};
export {
  ScalarHeadingVue,
  ScalarPageTitleVue,
  scalarHeading,
  scalarPageTitle
};
//# sourceMappingURL=index.js.map
